import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator for MAC address format
 * Accepts formats: XX:XX:XX:XX:XX:XX or XX-XX-XX-XX-XX-XX
 * Where XX are hexadecimal characters (0-9, A-F, a-f)
 */
export function macAddressValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values
    }

    const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
    const isValid = macRegex.test(control.value);

    return isValid ? null : { 
      macAddress: { 
        value: control.value,
        message: 'MAC-Adresse muss das Format XX:XX:XX:XX:XX:XX oder XX-XX-XX-XX-XX-XX haben'
      } 
    };
  };
}

/**
 * Validates package dimensions to ensure they are positive numbers
 */
export function packageDimensionValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = Number(control.value);
    
    if (isNaN(value) || value < 0 || value > 10000) {
      return { 
        packageDimension: { 
          value: control.value,
          message: 'Wert muss zwischen 0 und 10000 liegen'
        } 
      };
    }

    return null;
  };
}

/**
 * Validates package weight to ensure it's a positive number
 */
export function packageWeightValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = Number(control.value);
    
    if (isNaN(value) || value < 0 || value > 1000000) {
      return { 
        packageWeight: { 
          value: control.value,
          message: 'Gewicht muss zwischen 0 und 1000000 g liegen'
        } 
      };
    }

    return null;
  };
}